import axios  from "axios"

export default {
    methods: {
        async downloadSourceFile(fileUrl, type, fileName = 'downloaded-file'){
            axios.get(fileUrl, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: type })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = fileName
                link.click()
                URL.revokeObjectURL(link.href)
                return Promise.resolve()
            }).catch(ee => {
                // console.log(ee)
                return Promise.reject(ee)
            })
        },

        async downloadBlobFile(blobdata, fileName = 'downloaded-file'){
            const blob = new Blob([blobdata], { type: 'application/octet-stream' });
            console.log('downloaddata',blob);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
        },

        async downloadBlob(blob, fileName) {
            const parsedFileName = typeof fileName === 'string' || typeof fileName === 'number' ? fileName.toString() : Date.now().toString();
            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a')
            downloadLink.href = url;
            downloadLink.download = parsedFileName;
            downloadLink.click();
            window.URL.revokeObjectURL(url);
        }
    },

}